import { ClientSide } from "~/@types";
import { IImageFields } from "~/@types/generated/contentful";
import { getBackgroundImageStyles } from "../utils/getBackgroundImageStyles";

export interface ContentfulCenteredImageProps {
  image: ClientSide<IImageFields>;
  className?: string;
  bg?: "fade" | "gradient" | "grey" | "transparent";
  transformations?: string; // transformations for TwicPicsURL
  width?: number; // width  for FrontifyURL
  style?: any;
  [k: string]: any;
}

export default function ContentfulCenteredImage({
  className = "",
  image,
  bg,
  style = {},
  transformations,
  width,
  ...otherProps
}: ContentfulCenteredImageProps) {
  return (
    <div
      data-content-type="image"
      data-module-title={image?.moduleTitle}
      role="img"
      aria-label={image?.alt ?? "background image"}
      className={`${className}`}
      {...otherProps}
      style={{
        ...getBackgroundImageStyles(image, bg, transformations, width),
        ...style,
      }}
    >
      {!image && "No image found"}
    </div>
  );
}
